import React, { Component } from "react";
import AppContainer from "components/AppContainer";
import CoursioAppContainer from "containers/CoursioAppContainer";
import Dashboard from "components/Route/Dashboard";
// import Settings from 'components/Route/Settings';
import MediaLibrary from "components/Route/MediaLibrary";
import MediaLibraryUpload from "components/MediaLibrary/MediaLibraryUpload";
import MediaLibraryDetailContainer from "components/Route/MediaLibrary/MediaLibraryDetailContainer";
import TasksContainer from "components/Route/TasksContainer";
import QuizContainer from "components/Route/QuizContainer";
import StatisticsContainer from "components/Route/StatisticsContainer";
import NotesContainer from "components/Route/NotesContainer";
import Students from "components/Route/Students";

import StudentDetailContainer from "../containers/StudentDetailContainer";
import StudentExportContainer from "containers/StudentExportContainer";
import InvitationDetailContainer from "containers/InvitationDetailContainer";
import Groups from "components/Route/Groups";
import GroupDetail from "components/Route/Group/Detail";

import Courses from "components/Route/Courses";
import CourseDetail from "components/Route/Course/Detail";
import CourseDetailContainer from "../containers/CourseDetailContainer";

import SubAccounts from "components/Route/SubAccounts";
import StripeCompletePurchase from "components/Store/StripeCompletePurchase";
import StripeCancelPurchase from "components/Store/StripeCancelPurchase";

import TaC from "../components/TaC/TaC";
import Invite from "components/Route/InviteWizard";
import Communication from "components/Route/Communication";
import StoreContainer from "components/Route/StoreContainer";
import StoreItemContainer from "containers/Store/StoreItem";
// import StoreDetailPurchase from 'components/Route/Store/DetailPurchase';

import DiscountDetailContainer from "components/Route/Discount/DiscountDetailContainer";
import Discounts from "components/Route/Discounts";
import AcceptInvitationContainer from "components/Route/Invitation/AcceptInvitationContainer";
import AcceptGiftContainer from "components/Route/Gift/AcceptGiftContainer";

import BundleDetailContainer from "components/Route/Bundle/BundleDetailContainer";
import Bundles from "components/Route/Bundles";

import Transactions from "components/Route/Transactions";
import TransactionDetail from "components/Route/Transaction/Detail";
import About from "components/Route/About";
import Help from "components/Route/Help";
import CoursePreviewContainer from "components/Route/Course/CoursePreviewContainer";
import NotFound from "components/Route/NotFound";
import CoursioError from "components/Route/CoursioError";
import CoursioDown from "components/Route/CoursioDown";
import Page from "components/Route/Page";
import ForgotPassword from "components/Route/ForgotPassword";
import RestorePassword from "components/Route/RestorePassword";
import LoginForm from "components/Route/Login";
import LoggedIn from "components/Route/LoggedIn";
import KlarnaConfirmationContainer from "components/Route/KlarnaConfirmationContainer";
import Logout from "components/Route/Logout";
import Incarnate from "components/Route/Incarnate";
import Wakeup from "components/Route/Wakeup";
import Checkout from "containers/Checkout";

import { Router, Route, IndexRoute } from "react-router";
import { history } from "helpers";
import svSE from "i18n/sv_SE";
import enUS from "i18n/en_US";
import IntlProvider from "components/IntlProvider";
import { mixin, RefluxMixin } from "Util";
import { AuthStore } from "stores";
import Config from "Config";

const messages = {
  en_US: enUS,
  sv_SE: svSE,
};

const requireLogin = (nextState, replace, callback) => {
  if (!AuthStore.isAuthenticated()) {
    replace({
      pathname: "/login",
      query: { nextPath: nextState.location.pathname },
    });
  }
  callback();
};

const GApackageHandler = (nextState, replace, callback) => {
  const { username, slug } = nextState.params;
  replace({
    pathname: `/store/${username}/package/${slug}`,
    query: { nextPath: nextState.location.pathname },
  });
  callback()
}

const isNumeric = (value) => !isNaN(parseFloat(value)) && isFinite(value);

let Landing;

const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
let subDomain;
if ("//" + domain !== Config.thisHost) {
  subDomain = domain.split(".").shift();
}

if (subDomain && !isNumeric(subDomain)) {
  Landing = <IndexRoute component={StoreContainer} />;
} else {
  Landing = <IndexRoute onEnter={requireLogin} component={Dashboard} />;
}

const routes = (
  <Route path="/">
    <Route component={AppContainer}>
      <Route path="/checkout/:username/:id/:type" component={Checkout} />
    </Route>
    <Route component={AppContainer}>
      {Landing}
      <Route
        onEnter={requireLogin}
        path="/account/login"
        component={Dashboard}
      />
      <Route onEnter={requireLogin} path="/dashboard" component={Dashboard} />
      <Route
        onEnter={requireLogin}
        path="/settings"
        getComponent={(location, cb) => {
          import("components/Route/Settings").then((module) =>
            cb(null, module.default)
          );
        }}
      />

      <Route
        onEnter={requireLogin}
        path="/tasks(/:courseId)(/:userId)(/:taskId)"
        component={TasksContainer}
      />
      <Route
        onEnter={requireLogin}
        path="/quiz(/:courseId)(/:userId)(/:taskId)"
        component={QuizContainer}
      />
      <Route
        onEnter={requireLogin}
        path="/communication"
        component={Communication}
      />

      <Route
        onEnter={requireLogin}
        path="/media-library/:directoryId"
        component={MediaLibrary}
      >
        <Route
          onEnter={requireLogin}
          path="/media-library/:directoryId/upload"
          component={MediaLibraryUpload}
        />
        <Route
          onEnter={requireLogin}
          path="/media-library/:directoryId/:fileId"
          component={MediaLibraryDetailContainer}
        />
      </Route>

      <Route
        onEnter={requireLogin}
        path="/media-library"
        component={MediaLibrary}
      >
        <Route
          onEnter={requireLogin}
          path="/media-library/upload"
          component={MediaLibraryUpload}
        />
        <Route
          onEnter={requireLogin}
          path="/media-library/:fileId"
          component={MediaLibraryDetailContainer}
        />
      </Route>

      <Route onEnter={requireLogin} path="/students" component={Students}>
        <Route
          onEnter={requireLogin}
          path="/student/export"
          component={StudentExportContainer}
        />
        <Route
          onEnter={requireLogin}
          path="/student/:studentId"
          component={StudentDetailContainer}
        />
        <Route
          onEnter={requireLogin}
          path="/invitation-detail/:invitationId"
          component={InvitationDetailContainer}
        />
      </Route>

      <Route path="/invitation/:hash" component={AcceptInvitationContainer} />
      <Route path="/gift(/:giftCode)" component={AcceptGiftContainer} />
      <Route onEnter={requireLogin} path="/groups" component={Groups}>
        <Route
          onEnter={requireLogin}
          path="/group/:groupId"
          component={GroupDetail}
        />
      </Route>

      <Route onEnter={requireLogin} path="/courses" component={Courses}>
        <Route
          onEnter={requireLogin}
          path="/course/:courseId"
          component={CourseDetailContainer}
        />
      </Route>

      <Route
        onEnter={requireLogin}
        path="/sub-accounts"
        components={SubAccounts}
      />

      <Route onEnter={requireLogin} path="/discounts" component={Discounts}>
        <Route
          onEnter={requireLogin}
          path="/discount/:discountId"
          component={DiscountDetailContainer}
        />
      </Route>

      <Route onEnter={requireLogin} path="/bundles" component={Bundles}>
        <Route
          onEnter={requireLogin}
          path="/bundle/:bundleId"
          component={BundleDetailContainer}
        />
      </Route>

      <Route
        onEnter={requireLogin}
        path="/transactions"
        component={Transactions}
      />
      <Route
        onEnter={requireLogin}
        path="/transaction/:transactionId"
        component={TransactionDetail}
      />

      <Route
        onEnter={GApackageHandler}
        path="/store/package/:username/:slug(/:purchase)"
        component={StoreItemContainer}
        type={2}
      />
      <Route
        path="/store/:username/package/:slug(/:purchase)"
        component={StoreItemContainer}
        type={2}
      />
      <Route
        path="/store/:username/:slug(/:purchase)"
        component={StoreItemContainer}
        type={1}
      />
      <Route path="/store(/:store)" component={StoreContainer} />

      <Route
        onEnter={requireLogin}
        path="/statistics"
        component={StatisticsContainer}
      />
      <Route onEnter={requireLogin} path="/notes" component={NotesContainer} />

      <Route
        onEnter={requireLogin}
        path="/checkout/stripe/success"
        component={StripeCompletePurchase}
      />

      <Route
        onEnter={requireLogin}
        path="/checkout/stripe/cancelled"
        component={StripeCancelPurchase}
      />

      <Route
        onEnter={requireLogin}
        path="/klarna/swish/done"
        component={StripeCompletePurchase}
      />

      <Route path="/terms-and-conditions" component={TaC} />

      <Route onEnter={requireLogin} path="/invite" component={Invite} />
      <Route
        onEnter={requireLogin}
        path="/klarna/confirm/:transactionId"
        component={KlarnaConfirmationContainer}
      />
      <Route path="/about/:username/:page" component={About} />
      <Route onEnter={requireLogin} path="/help" component={Help} />

      <Route path="/login" component={LoginForm} />
      <Route path="/logged-in" component={LoggedIn} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/restore-password/:key" component={RestorePassword} />
      <Route path="/logout" onEnter={requireLogin} component={Logout} />
      <Route onEnter={requireLogin} path="/incarnate" component={Incarnate} />
      <Route onEnter={requireLogin} path="/wakeup" component={Wakeup} />

      <Route
        onEnter={requireLogin}
        path="/course/:ownerSlug/:courseSlug"
        component={CoursePreviewContainer}
      >
        <Route
          onEnter={requireLogin}
          path="/course/:ownerSlug/:courseSlug/:sectionSlug/:pageSlug/:pageId"
          component={Page}
        />
        <Route
          onEnter={requireLogin}
          path="/builder/course/:ownerSlug/:courseSlug/:sectionSlug/:pageSlug"
          component={Page}
        />
        <Route
          onEnter={requireLogin}
          path="/course/:ownerSlug/:courseSlug/:sectionSlug/:pageSlug"
          component={Page}
        />
        <Route
          onEnter={requireLogin}
          path="/course/:ownerSlug/:courseSlug/:pageId"
          component={Page}
        />
      </Route>
      <Route path="/coursio-error" component={CoursioError} />
      <Route path="/down" component={CoursioDown} />
      <Route path="*" component={NotFound} />
    </Route>
  </Route>
);

class AppWrapper extends mixin(RefluxMixin, Component) {
  static displayName = "AppWrapper";

  listenToStores() {
    this.listenToStore(AuthStore);
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return false;
  // }

  render() {
    const { locale } = this.state;
    return (
      <IntlProvider locale={locale} {...messages[locale]}>
        <Router history={history}>{routes}</Router>
      </IntlProvider>
    );
  }
}

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/js/components/AppWrapper.js